import React from "react";
import UserDefaultAvatar from "assets/img/user.svg";
import "assets/scss/helpers/avatar.scss";
import classNames from "classnames";

export default ({ src, style, rootStyle, onClick, className, alt }) => {
  const avatarClasses = classNames({
    img: true,
    [className]: true,
  });

  const checkSrc = (e) => {
    e.target.src = UserDefaultAvatar;
  };

  return (
    <div className="avatar" style={rootStyle}>
      <img
        onError={checkSrc}
        className={avatarClasses}
        style={style}
        onClick={onClick}
        src={src}
        alt={`${alt}`}
      />
    </div>
  );
};
